import type { PolicyLevel, PolicySortBy } from '../types';

export const POLICY_LEVEL_LABELS: Record<PolicyLevel, string> = {
  national: '国家级',
  provincial: '省级',
  city: '地级市',
  park: '园区级',
};

export const POLICY_LEVEL_OPTIONS = [
  { label: '全部层级', value: 'all' },
  { label: POLICY_LEVEL_LABELS.national, value: 'national' },
  { label: POLICY_LEVEL_LABELS.provincial, value: 'provincial' },
  { label: POLICY_LEVEL_LABELS.city, value: 'city' },
  { label: POLICY_LEVEL_LABELS.park, value: 'park' },
];

export const POLICY_SORT_OPTIONS: Array<{ label: string; value: PolicySortBy }> = [
  { label: '发布时间最新', value: 'issuedAtDesc' },
  { label: '发布时间最早', value: 'issuedAtAsc' },
  { label: '相关度优先', value: 'relevance' },
];
